module.exports = __webpack_public_path__ + "img/kof_yes.2f4292d8.png";